import { createReducer } from "@reduxjs/toolkit"

import { IBcaState } from "../interfaces/bca/IBcaState"
import { setAllBcaMetricNames } from "../actions/bcaDataActions"

const init = {
	allMetrics: {},
} as IBcaState

export const bcaDataReducer = createReducer(init, (builder) => {
	builder.addCase(setAllBcaMetricNames, (state, action) => {
		state.allMetrics = action.payload
	})
})
